import { es } from "@/i18n/es";

export const useTranslation = () => {
  return {
    t: (path: string, params?: Record<string, string | number>) => {
      let text = path.split(".").reduce((obj, key) => obj[key as keyof typeof obj] ?? key, es as any);

      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          // If the value is a number, format it with locale
          if (typeof value === "number") {
            text = text.replace(
              `{${key}}`,
              value.toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            );
          } else {
            text = text.replace(`{${key}}`, value.toString());
          }
        });
      }

      return text;
    },
  };
};
